var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"WeeklyProgressPanel"},[_c('div',{staticClass:"title"},[_vm._v("\n        "+_vm._s(_vm.$t('weeklyHeartTitle'))+"\n    ")]),_c('HeartGraph',{attrs:{"data":_vm.braindatesForCurrentWeek}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }